
















































import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import AppCenterModal from '@/components/AppCenterModal.vue'
import AppCheckRound from '@/components/AppCheckRound.vue'
import AppConfirmModal from '@/components/AppConfirmModal.vue'
import AppSectionBanners from '@/components/AppSectionBanners.vue'
import AppTitleBar from '@/components/AppTitleBar.vue'
import { Common } from '@/mixins'

@Component({
  components: {
    AppCenterModal,
    AppCheckRound,
    AppConfirmModal,
    AppSectionBanners,
    AppTitleBar
  }
})
export default class extends Mixins(Common) {
  isModalActive = false
  isSubmittedModalActive = false
  isChecked = false
  snsInfo = ''

  get isSubmitEnabled () {
    return this.isChecked && this.snsInfo
  }

  async onClickApply () {
    await this.showLoading()
    try {
      await this.$apollo.mutate({
        mutation: gql`mutation ($input: RequestPepperRegistrationInput!) {
          requestPepperRegistration(input: $input) {
            message
            user {
              id
              hasActivePepperRegistration
            }
          }
        }`,
        variables: {
          input: {
            snsInfo: this.snsInfo
          }
        }
      })
      this.isModalActive = false
      this.isSubmittedModalActive = true
    } finally {
      await this.dismissLoading()
    }
  }
}
